import React from "react";
import Map from "../../components/Contact/Map";
import "./Contact.scss";

const Contact = () => {
  return (
    <>
      <Map />
    </>
  );
};

export default Contact;
